import styled from 'styled-components'
import { StyledButton } from './StyledButton'
import { Action } from '../styles/mixins'
import { IThemeProps } from '../../../models/interfaces'

export const SecondaryButton = styled(StyledButton).withConfig({
  shouldForwardProp: (prop) => !['height'].includes(prop as string),
})`
  padding: 10px var(--gutter-2x);

  ${(props: IThemeProps) =>
    Action({
      lineHeight: 0,
      // @ts-expect-error: fix in PORT-2536
      height: `${props.height || 'var(--button-size-xs)'}`,
      color: props.theme.colors?.font?.dark || 'var(--font-color-dark)',
      backgroundColor:
        props.theme.colors?.background?.primary ||
        'var(--background-color-default)',

      border: {
        width: '1px',
        color:
          props.theme.colors?.border?.primary || 'var(--border-color-default)',
        style: 'solid',
        radius: '2px',
      },
      borderBottom: {
        width: '2px',
      },

      hoverAction: {
        opacity: '0.5',
        backgroundColor:
          props.theme.colors?.background?.primary ||
          'var(--background-color-default)',
        border: {
          width: '1px',
          style: 'solid',
          color:
            props.theme.colors?.border?.primary ||
            'var(--border-color-default)',
          radius: '2px',
        },
        borderBottom: {
          width: '2px',
        },
      },

      disableAction: {
        backgroundColor:
          props.theme.colors?.background?.primary ||
          'var(--background-color-default)',
        border: {
          width: '1x',
          style: 'solid',
          color:
            props.theme.colors?.border?.primary ||
            'var(--border-color-default)',
          radius: '2px',
        },
        borderBottom: {
          width: '2px',
        },
      },
    })}
`
